import { Button, Col, Divider, Form, Input, Row, Select, Space } from "antd";
import { EmpresaState } from "../../../../redux/slices/empresa/empresaSlice";
import { useAppDispatch, useAppSelector } from "../../../../util/hooks";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { ConsignatarioState, setModalDadosUsuarioConsignatario } from "../../../../redux/slices/consignatario/consignatarioSlice";
import { EmpresaModel } from "../../../../models/empresa/empresaModel";
import { buscarConsignatario, gerarDadosUsuarioConsignatario } from "../../../../services/consiganatarioService";
import { useEffect } from "react";
import { GerarDadosUsuarioConsignatarioModel } from "../../../../models/consignatario/chamadas/gerarDadosUsuarioConsignatarioModel";

interface DadosUsuarioModalForm {
  email: string;
  password: string;
  nome: string;
  perfil: string;
  idEmpresa: number;
}

const DadosUsuarioModal = () => {
  //estados globais
  const consignatarioState = useAppSelector((state) => state.consignatario);
  const empresaState = useAppSelector((state) => state.empresa);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm<DadosUsuarioModalForm>();

  useEffect(() => {
    form.setFieldsValue({ perfil: "consignatario", idEmpresa: consignatarioState.entity.idEmpresa, nome: consignatarioState.entity.apelido });
  }, [consignatarioState.entity]);

  const submit = (values: DadosUsuarioModalForm) => {
    dispatch(gerarDadosUsuarioConsignatario({ value: { ...values, idConsignatario: consignatarioState.entity.id }, busca: consignatarioState.busca }));
  };

  const voltar = () => {
    dispatch(setModalDadosUsuarioConsignatario(false));
  };

  return (
    <Form form={form} layout="vertical" onFinish={submit}>
      <Row gutter={12}>
        <Col span={12}>
          <Form.Item
            label="Endereço de e-mail"
            name="email"
            rules={[
              {
                required: true,
                message: "Digite seu email",
              },
            ]}
          >
            <Input type="text" placeholder="Digite seu e-mail" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Digite sua senha"
            name="password"
            rules={[
              {
                required: true,
                message: "Digite sua senha",
              },
            ]}
          >
            <Input type="password" placeholder="Digite sua senha" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={12}>
        <Col span={8}>
          <Form.Item
            label="Nome"
            name="nome"
            rules={[
              {
                required: true,
                message: "Digite seu nome",
              },
            ]}
          >
            <Input type="text" placeholder="Digite seu nome" />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="Selecione o perfil"
            name="perfil"
            rules={[
              {
                required: true,
                message: "Selecione pelo menos um perfil",
              },
            ]}
          >
            <Select
              placeholder="Selecione o perfil"
              disabled
              options={[
                {
                  value: "consignatario",
                  label: "CONSIGNATARIO",
                },
              ]}
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="Selecione a empresa"
            name="idEmpresa"
            rules={[
              {
                required: true,
                message: "Selecione pelo menos uma empresa",
              },
            ]}
          >
            <Select
              showSearch
              optionFilterProp="label"
              placeholder="Selecione a empresa"
              disabled
              options={empresaState.list.map((a: EmpresaModel) => ({
                value: a.id,
                label: a.apelido,
              }))}
            />
          </Form.Item>
        </Col>
      </Row>
      <Divider />
      <Row gutter={12}>
        <Col span={24} className="modalFooter">
          <Space size="middle">
            <Button className="cancelButton" onClick={voltar} icon={<CloseOutlined />}>
              FECHAR
            </Button>
            <Button htmlType="submit" icon={<CheckOutlined />} className="buttonPrimary">
              SALVAR
            </Button>
          </Space>
        </Col>
      </Row>
    </Form>
  );
};

export default DadosUsuarioModal;
